import type { Site } from '../Site';

export const Rooms: Site = {
  id: 'rooms',
  analyticsName: 'rooms',
  selector: '',
  logo: '',
  label: 'Rooms',
  platform: '',
};
